var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbumsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6467 8.25H4.35328C3.60588 8.25 3 8.85588 3 9.60328V18.8967C3 19.6441 3.60588 20.25 4.35328 20.25H19.6467C20.3941 20.25 21 19.6441 21 18.8967V9.60328C21 8.85588 20.3941 8.25 19.6467 8.25Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75H17.25H6.75ZM5.25 6H18.75H5.25Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.75H17.25M5.25 6H18.75",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumsOutline);
export default __webpack_public_path__ + "static/media/albums-outline.cdab8381994621c1fd867f56c333a53f.svg";
export { ForwardRef as ReactComponent };